import theme from '@styles/theme';
export default {
  smallBlockHeader: (bg: string) => ({
    bg,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  smallBlockContent: {
    width: '100%',
    p: ['64px 40px 20px 40px', '64px 40px 20px 40px', '64px 40px 20px 40px', '128px 54px 20px 64px', '208px 175px 20px 195px'],
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    div: {
      width: '100%',
      p: {
        width: ['auto', 'auto', 300, 400],
        fontSize: [theme.fontSizes.caption, theme.fontSizes.text, theme.fontSizes.text, theme.fontSizes.text]
      }
    },
    imageContainer: {
      position: 'relative',
      width: ['100vw', '100vw', '42.578125vw', '25.15625vw'],
      height: ['51.2vw', '51.2vw', '26.5625vw', '15vw'],
      maxWidth: '483px',
      maxHeight: '288px'
    }
  }
};